<div class="page">
  <div class="subheader">
    <i class="subicon icon-angle-double-left" (click)="order.closeSidebar()"></i>

    <i class="usericon icon-people_alt-o"></i
    ><span>{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.ClubTitle" | translate }}</span>
  </div>
  <div class="content">
    <div class="box">
      <div class="credit-box">
        <ssg-input
          class="conent-box"
          (valueChange)="ClubCodeChange($event)"
          (click)="clubAction = clubModelEnum.Code"
          isNumberOnly="true"
          textType="text"
          isDecimal="true"
          [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.CreditCode' | translate"
          name="CreditCode"
          [group]="formGroup"
          (onEnter)="GetCustomerInquiry()"
          hasClear="true"></ssg-input>
        <ssg-button
          class="credit"
          (click)="GetCustomerInquiry()"
          [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.Credit' | translate"></ssg-button>
      </div>
      <div class="precent-box">
        <div>
          <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.Balance" | translate }} : </span>
          <span>
            {{ this.order.invoice.ClubViewModel?.AvailableCredit | number }}
            {{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.UnitPrice" | translate }}
          </span>
        </div>
        <div>
          <div>
            <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.DiscountPercent" | translate }} : </span>
            <span>{{ this.order.invoice.ClubViewModel?.DiscountPercent }} ٪</span>
          </div>
          <div class="precent-box">
            <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.PercentCredit" | translate }} : </span>
            <span>
              {{ this.order.invoice.ClubViewModel?.DiscountPrice | number }}
              {{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.UnitPrice" | translate }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="credit-box">
      <ssg-input
        class="conent-box"
        (valueChange)="CreditPriceChange($event)"
        (click)="clubAction = clubModelEnum.UseCredit"
        (keyup)="ChangeInput($event)"
        textType="currency"
        [withComma]="true"
        [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.UseCreditTitle' | translate"
        name="UseCredit"
        [group]="formGroup"
        hasClear="true"></ssg-input>
      <ssg-button
        class="credit"
        (click)="UseCredit()"
        [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.UseCredit' | translate"></ssg-button>
    </div>
    <div class="credit-num"></div>
    <div class="sum-creat">
      <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.SumCredit" | translate }} : </span>
      <span
        >{{ this.order.invoice?.ClubViewModel?.UseCreditPrice | number }}
        {{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.UnitPrice" | translate }}</span
      >
    </div>
    <div class="footer">
      <div class="resend-code">
        <ssg-input
          class="conent-box"
          (onEnter)="SendCodeToCustomer()"
          [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.Phone' | translate"
          textType="currency"
          name="Phone"
          [group]="formGroup"
          category="NumberType"
          (click)="clubAction = clubModelEnum.Mobile"
          hasClear="true"></ssg-input>

        <ssg-button
          (click)="SendCodeToCustomer()"
          class="resed-btn"
          [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.Resend' | translate"
          class="resend">
        </ssg-button>
      </div>
      <div class="test-club calling">
        <ssg-input
          class="conent-box"
          [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.PhoneSupport' | translate"
          textType="currency"
          name="OperatorPhone"
          [group]="formGroup"
          category="NumberType"
          (click)="clubAction = clubModelEnum.SupportNumber"
          (onEnter)="NeedSmartSupport()"></ssg-input>
        <ssg-button
          class="resed-btn testbtn"
          (click)="NeedSmartSupport()"
          [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.PhoneNumber' | translate"
          class="resend">
        </ssg-button>
      </div>

      <div class="test-club">
        <ssg-button
          class="resed-btn testbtn reset resend"
          (click)="Reset()"
          [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.Reset' | translate">
        </ssg-button>

        <ssg-button
          class="resed-btn testbtn resend"
          (click)="HealthCheckClub()"
          [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.testClub' | translate">
        </ssg-button>
      </div>
      <div class="show-customer">
        <ssg-button
          class="resend"
          (click)="showCustomerForm()"
          [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.CustomerInfo' | translate">
        </ssg-button>
      </div>
    </div>
  </div>
  <div class="button">
    <div class="d-flex">
      <ssg-button class="number" (click)="SetInputNumber('9')" label="9"></ssg-button>
      <ssg-button class="number" (click)="SetInputNumber('8')" label="8"></ssg-button>
      <ssg-button class="number" (click)="SetInputNumber('7')" label="7"></ssg-button>
    </div>
    <div class="d-flex">
      <ssg-button class="number" (click)="SetInputNumber('6')" label="6"></ssg-button>
      <ssg-button class="number" (click)="SetInputNumber('5')" label="5"></ssg-button>
      <ssg-button class="number" (click)="SetInputNumber('4')" label="4"></ssg-button>
    </div>
    <div class="d-flex">
      <ssg-button class="number" (click)="SetInputNumber('3')" label="3"></ssg-button>
      <ssg-button class="number" (click)="SetInputNumber('2')" label="2"></ssg-button>
      <ssg-button class="number" (click)="SetInputNumber('1')" label="1"></ssg-button>
    </div>
    <div class="d-flex">
      <ssg-button class="number rotateicon arrowleftSize" icon="icon-long-arrow-left" (click)="BackInputNumber()"></ssg-button>
      <ssg-button class="number ziro" (click)="SetInputNumber('0')" label="0"></ssg-button>
      <ssg-button class="number" label="C" (click)="DeleteInputNumber()"></ssg-button>
    </div>
  </div>
</div>
